import React, { useEffect, useRef } from "react";
import { Parallax } from "react-parallax";
import { reviews } from "../../data";

const Reviews = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const scrollStep = 1.5; // adjust the scrolling speed here
    let scrollAmount = 0;
    let scrollDirection = "right";
    let animationFrameId;

    const scroll = () => {
      if (scrollDirection === "right") {
        scrollAmount += scrollStep;
        container.scrollLeft = scrollAmount;

        // Change direction when reaching the end
        if (scrollAmount >= container.scrollWidth - container.clientWidth) {
          scrollDirection = "left";
        }
      } else {
        scrollAmount -= scrollStep;
        container.scrollLeft = scrollAmount;

        // Change direction when reaching the start
        if (scrollAmount <= 0) {
          scrollDirection = "right";
        }
      }

      animationFrameId = requestAnimationFrame(scroll);
    };

    const handleIntersection = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        // Start scrolling when the parent div is in view
        animationFrameId = requestAnimationFrame(scroll);
      } else {
        // Stop scrolling when the parent div is out of view
        cancelAnimationFrame(animationFrameId);
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    });

    observer.observe(container);

    // Clean up the observer and animation frame when the component unmounts
    return () => {
      observer.unobserve(container);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  const RatingStars = ({ rating }) => {
    // Create an array with 5 elements representing the stars
    const totalStars = 5;
    const stars = Array.from({ length: totalStars }, (_, index) => (
      <span key={index} className="material-icons-outlined text-[#ecac09]">
        {index < rating ? "star" : "star_outline"}
      </span>
    ));

    return <div className="ratings">{stars}</div>;
  };

  return (
    <Parallax
      blur={2}
      bgImage="/assets/images/reviews/reviews-bg.webp"
      bgImageAlt="reviews"
      bgClassName="object-cover"
      strength={500}
      className="bg-black/10 flex flex-col items-center w-full relative"
      contentClassName="bg-black/60 w-full h-full py-10 text-white flex justify-center"
    >
      <div className="h-full flex flex-col text-center items-center justify-center py-5 gap-5  w-full overflow-hidden">
        <div className="max-w-screen-xl flex flex-col text-center items-center justify-center gap-5 px-5 xl:px-0">
          <p className="text-7xl stroke-black mb-3">Clients’ Reviews</p>
          <p className="text-lg">
            We believe that our clients' experiences speak volumes about the
            quality of our services. Your satisfaction is our greatest reward,
            and we're excited to share the stories of our happy clients with
            you.
          </p>
        </div>
        <div
          className="flex flex-nowrap items-center justify-start gap-5 no-scrollbar overflow-auto w-full relative mt-7"
          ref={containerRef}
        >
          {reviews.map((review, index) => (
            <div
              className="flex p-3 bg-[#eff1f0] shadow-md min-w-[620px] h-[240px] last-of-type:mr-5 first-of-type:ml-5 scale-75 md:scale-100"
              key={index}
            >
              <div className="relative h-full flex items-center">
                <img
                  src="/assets/images/reviews/art.svg"
                  alt=""
                  className="art-top"
                />
                <img
                  src={review.image}
                  alt=""
                  className="relative z-10 ml-5 h-[180px] w-[180px] max-w-none"
                />
                <img
                  src="/assets/images/reviews/art.svg"
                  alt=""
                  className="art-bottom"
                />
              </div>
              <div className="flex pt-2.5 pl-[30px] pr-2.5 justify-between flex-col">
                <div className="text-left">
                  <div className="text-lg text-black/90 font-semibold mb-2.5">
                    {review.name}
                  </div>
                  <div className=" text-sm text-black/90 line-height-15">
                    {review.description}
                  </div>
                </div>
                <div className="flex justify-between items-center w-full pb-1">
                  <RatingStars rating={review.rating} />
                  {/* <img
                    src={`/assets/images/reviews/${review.platform}.svg`}
                    alt=""
                    className="w-10 h-10"
                  /> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Parallax>
  );
};

export default Reviews;
